import AddFileProviderView from './AddFileProviderView';
import FileProviderAndScopesView from './FileProviderAndScopesView';
import LocalComputerFileProviderView from './LocalComputerFileProviderView';
import changeSelectedFileProvider from '../actions/changeSelectedFileProvider';
import clearSelectedFileProviderItems from '../actions/clearSelectedFileProviderItems';
import FilePickerPanelViewState from '../store/schema/FilePickerPanelViewState';
import getAddedProviders from '../utils/getAddedProviders';
import { observer } from 'mobx-react';
import { FocusZone, FocusZoneDirection } from 'office-ui-fabric-react/lib/FocusZone';
import { logUsage } from 'owa-analytics';
import { getProviderLoadState } from 'owa-fileprovider-store/lib/selectors/getProviderLoadState';
import AttachmentDataProviderScope from 'owa-service/lib/contract/AttachmentDataProviderScope';
import * as React from 'react';
import {
    FileProviderViewState,
    FileSelectionFilter,
    ProviderLoadStateOption,
} from 'owa-fileprovider-store';

const classNames = require('classnames');
const styles = require('./FileProvidersPane.scss');

export interface FileProvidersPaneProps extends React.HTMLProps<HTMLDivElement> {
    fileSelectionFilter: FileSelectionFilter;
    onLocalComputerFilesSelected: (files: File[], fileSelectionFilter: FileSelectionFilter) => void;
    filePickerPanelViewState: FilePickerPanelViewState;

    // Optional
    selectedFileProvider?: FileProviderViewState;
    disableLocalComputerFilePicker?: boolean;
    showFileProviderInlineView?: boolean;
}

@observer
export default class FileProvidersPane extends React.Component<FileProvidersPaneProps, {}> {
    render() {
        const providersLoaded = getProviderLoadState() === ProviderLoadStateOption.Loaded;
        return (
            <div className={styles.container}>
                <FocusZone
                    className={classNames(styles.fileProviders, 'customScrollBar')}
                    isCircularNavigation={false}
                    direction={FocusZoneDirection.vertical}>
                    {!this.props.disableLocalComputerFilePicker && (
                        <LocalComputerFileProviderView
                            fileSelectionFilter={this.props.fileSelectionFilter}
                            onFilesSelected={this.props.onLocalComputerFilesSelected}
                            onLocalComputerClicked={this.onLocalComputerClicked}
                        />
                    )}

                    {providersLoaded &&
                        this.createFileProvidersView(
                            getAddedProviders(this.props.fileSelectionFilter)
                        )}
                    {providersLoaded && <AddFileProviderView />}
                </FocusZone>
            </div>
        );
    }

    private onLocalComputerClicked = () => {
        clearSelectedFileProviderItems(this.props.filePickerPanelViewState.filePickerViewState);
        logUsage('FPLocalComputerClicked');
    };

    private createFileProvidersView(providers: FileProviderViewState[]): JSX.Element[] {
        return providers.map(providerViewState => {
            return this.createFileProviderAndScopesView(
                providerViewState,
                providerViewState === this.props.selectedFileProvider &&
                    !this.props.showFileProviderInlineView,
                this.props.filePickerPanelViewState
            );
        });
    }

    private createFileProviderAndScopesView(
        viewState: FileProviderViewState,
        isSelected: boolean,
        filePickerViewState: FilePickerPanelViewState
    ) {
        const onClickGenerator = (scope: AttachmentDataProviderScope) => () => {
            changeSelectedFileProvider(viewState, filePickerViewState, scope);
        };

        return (
            <FileProviderAndScopesView
                key={viewState.viewType}
                name={viewState.name}
                providerType={viewState.viewType}
                isSelected={isSelected}
                selectedScope={filePickerViewState.selectedProviderScope}
                onClickGenerator={onClickGenerator}
                scopes={viewState.scopes}
            />
        );
    }
}
